import PropTypes from 'prop-types';

export const attributeOptionPropType = PropTypes.exact({
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
});
